export default __webpack_public_path__ + "static/media/saveAsTr.170665ee.svg";